import { jsx as _jsx } from "react/jsx-runtime";
import { useAnalyticsUtilities } from "@air/analytics";
import LogRocket from "logrocket";
import { createContext, useContext, useMemo } from "react";
import { useSubscription } from "~/swr-hooks/subscriptions/useSubscription";
import { isDevOrTestStage } from "~/swr-hooks/utils";
import { reportErrorToBugsnag } from "~/utils/ErrorUtils";
import { useAccountContext } from "./AccountProvider";
const defaultValue = {
    data: undefined
};
const SubscriptionProviderContext = /*#__PURE__*/ createContext(defaultValue);
export const SubscriptionProvider = (param)=>{
    let { children } = param;
    const { data: account } = useAccountContext();
    const { setGlobalEventProps } = useAnalyticsUtilities();
    const { data: subscription, error } = useSubscription();
    const value = useMemo(()=>({
            data: subscription,
            error
        }), [
        subscription,
        error
    ]);
    if (subscription) {
        if (account) {
            LogRocket.identify(account.email, {
                plan: subscription.plan
            });
        }
        setGlobalEventProps({
            plan: subscription.plan
        });
    }
    return /*#__PURE__*/ _jsx(SubscriptionProviderContext.Provider, {
        value: value,
        children: children
    });
};
export const useSubscriptionContext = ()=>{
    const context = useContext(SubscriptionProviderContext);
    if (context === defaultValue) {
        const error = "SubscriptionProviderContext used outside of SubscriptionProvider";
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: error
            });
        }
    }
    return context;
};
